import CTNButton from '@ctn/ui/components/ctn-button';
import CTNInput from '@ctn/ui/components/ctn-input';
import CTNRadioButton from '@ctn/ui/components/ctn-radio-button';
import CTNCheckBox from '@ctn/ui/components/ctn-checkbox';
import { useState, type ReactElement } from 'react';
import { useForm } from 'react-hook-form';
import ResponseAlta from '../../components/ResponseAlta';
import type { IForm } from '../../interfaces/model/IForm.interface';
import { defaultValues, resolver } from './form';
import type { CTNCheckBoxItemProps } from '@ctn/ui/types/ctn-checkbox';
import { handleDescarga } from '../../utils/descarga';
import icon from '@ctn/ui/components/ctn-icon/icon';

const DESCARGAPROGRAMA = process.env.REACT_APP_DESCARGA_PDF;

const Home = (): ReactElement => {
	const [formData, setFormData] = useState<IForm | undefined>(undefined);
	const {
		control,
		formState: { errors },
		handleSubmit,
		watch,
	} = useForm<IForm>({
		mode: 'onSubmit',
		resolver,
		defaultValues,
	});

	const watchCheckbox = watch('privacyPolicy');

	const items = [
		{
			label: 'Presencial',
			value: 'presencial',
		},
		{
			label: 'Streaming',
			value: 'streaming',
		},
	];

	const checkboxItem: CTNCheckBoxItemProps[] = [
		{
			label: 'Acepto la política de privacidad.',
			value: 'accept',
		},
	];

	const descargarPrograma = () => {
		if (DESCARGAPROGRAMA) {
			handleDescarga(DESCARGAPROGRAMA, 'programa-jornadas-tecnologias.pdf');
		} else {
			console.error('La URL para la descarga no está definida');
		}
	};

	const onSendForm = (form: IForm) => {
		setFormData(form);
	};

	return (
		<form className="[ o-layout__body ] [ p-home ]" onSubmit={handleSubmit(onSendForm)}>
			{formData ? (
				<ResponseAlta formData={formData} />
			) : (
				<>
					<div role="group" aria-labelledby="sign-head">
						<div className="p-home__header">
							<p id="sign-head">Inscripción</p>

							<CTNButton
								key="programa"
								label="PROGRAMA"
								variant="ghost"
								mode="tertiary"
								className="p-home__btn"
								icon={[{ icon: 'download', position: 'right' }]}
								onClick={descargarPrograma}
							/>
						</div>
						<div className="[ o-grid ] [ u-mt-24 ]">
							<div className="o-grid__row">
								<div className="o-grid__col-3@desktop">
									<CTNInput
										condensed
										required
										name="name"
										label="NOMBRE"
										type="text"
										control={control}
										error={errors.name?.message}
									/>
								</div>
								<div className="o-grid__col-3@desktop">
									<CTNInput
										condensed
										required
										name="surnames"
										label="APELLIDOS"
										type="text"
										control={control}
										error={errors.surnames?.message}
									/>
								</div>
								<div className="o-grid__col-6@desktop">
									<CTNInput
										condensed
										required
										name="entity"
										label="ENTIDAD"
										type="text"
										control={control}
										error={errors.entity?.message}
									/>
								</div>
							</div>
							<div className="o-grid__row">
								<div className="o-grid__col-6@desktop">
									<CTNInput
										condensed
										required
										name="email"
										label="EMAIL"
										type="text"
										control={control}
										error={errors.email?.message}
									/>
								</div>
								<div className="o-grid__col-6@desktop">
									<CTNRadioButton
										required
										classNameRadio="c-jt-radiobutton"
										columns={2}
										layout="inline"
										name="assist"
										field={{ label: 'ASISTENCIA' }}
										radioButton={{ large: true }}
										items={items}
										control={control}
										error={errors.assist?.message}
									/>
								</div>
							</div>
						</div>
					</div>

					<div className="c-jt-privacy" role="group" aria-labelledby="privacy-head">
						<p className="c-jt-privacy__tit" id="privacy-head">
							POLÍTICA DE PRIVACIDAD
						</p>
						<p className="c-jt-privacy__body">
							Se informa que sus datos personales serán tratados como responsable del tratamiento por el
							Consejo General del Notariado, domiciliado en calle Silvano, 55, 28043 Madrid. Los datos
							facilitados se utilizarán con la finalidad de gestionar su participación en el evento en
							base a su consentimiento. Los datos no serán comunicados a terceros. Los datos serán
							conservados mientras sean necesarios para la finalidad para la que fueron recabados. El
							usuario podrá ejercer los referidos derechos respecto a los datos personales suministrados
							mediante petición escrita dirigida a la dirección de correo electrónico
							derechosRGPD@notariado.org. Así mismo el usuario tiene derecho a retirar el consentimiento
							prestado en cualquier momento, mediante el mismo procedimiento. Frente a cualquier
							vulneración de sus derechos, puede usted presentar una reclamación ante la Agencia Española
							de Protección de Datos. Los datos de contacto del Delegado de Protección de Datos son: Calle
							Silvano, 55 - 28043 Madrid - España. Email: dpd@notariado.org.
						</p>
						<div className="c-jt-checkbox">
							<CTNCheckBox
								required
								columns={1}
								name="privacyPolicy"
								classNameField="u-mt-8"
								items={checkboxItem}
								checkbox={{ large: true }}
								control={control}
								error=""
							/>
						</div>
					</div>
					<CTNButton
						key="inscribirse"
						disabled={watchCheckbox.length <= 0}
						className="c-jt-button"
						label="INSCRIBIRSE"
						type="submit"
						size="size-40"
					/>
				</>
			)}
		</form>
	);
};

export default Home;
